import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "transaction-detail-page" }
const _hoisted_2 = { class: "flex items-center justify-end mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "md:flex items-center gap-4"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tidak Cocok")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cocok")
const _hoisted_6 = {
  key: 1,
  class: "md:flex items-center gap-4"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Batal Refund")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Refund")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex items-center justify-end mt-30px" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, /*#__PURE__*/_toDisplayString('Alasan Transaksi Tidak Cocok'), -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, /*#__PURE__*/_toDisplayString('Keterangan Batal Refund'), -1)

import { ref, onMounted } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import FuelingTransactionDetailCard from '@/views/shared-components/FuelingTransactionDetailCard.vue'
import { getFullImageUrl } from '@/utils/helpers/fuelTransactionHelper'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useFuelTransactionDetail } from '@/composables/pages/externals/fuel-monitoring/useFuelTransactionDetail'
import apiUseCase from '@/usecase/apiUseCase'
import { checkActionAllowedRoles } from '@/utils/helpers/checkActionAllowedRoles'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import PendingPage from '../components/PendingPage.vue'
import FinanceRefundForm from '../components/FinanceRefundForm.vue'
import FinanceCompletedPage from '../components/FinanceCompletedPage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionDetail',
  setup(__props) {

const fuelingPaymentBatchEndpoint = 'transaction/v2/FuelingPaymentBatches'
const filterStorageKey = 'fuel-payment-batch-detail-filters'
const route = useRoute()
const router = useRouter()
const store = useStore()
const showEvidenceImage = ref(false)
const showTransactionHistory = ref(false)
const origin = ref(null) as any
const isShowCheckerPendingDialog = ref(false)
const isShowFinanceRefundForm = ref(false)
const isShowFinanceCompletedForm = ref(false)
const headerData = ref(null) as any

onBeforeRouteLeave((to) => {
  if (to.name !== 'fuel-payment-batch-detail') {
    sessionStorage.removeItem(filterStorageKey)
  }
})

const {
  isLoadingDetail,
  isLoadingHistory,
  transactionDetail,
  historyData,
  activeHistoryTab,
  historyPaginate,
  onChangeHistoryTab,
  onChangeHistoryPage,
  fetchHistory,
  $toast
} = useFuelTransactionDetail()

const fetchDetailData = async (id: string) => {
  isLoadingDetail.value = true
  try {
    const response = await apiUseCase.get(`/transaction/v2/FuelingTransactions/${id}`)
    if (!response.error) {
      transactionDetail.value = response.result

      // Update breadcrumbs once we have the code
      store.dispatch('ui/setBreadcrumbs', headerData.value ? [
        { title: 'Batch Pembayaran BBM', routeName: 'fuel-payment-batch' },
        {
          title: `Detail Batch - ${headerData.value?.Code}`,
          routeName: 'fuel-payment-batch-detail',
          params: { id: encryptDecriptMethods.encrypt({ origin: origin.value, data: headerData.value }) }
        },
        { title: `Detail Transaksi - ${response.result.Code}`, routeName: 'fuel-payment-batch-transaction-detail' }
      ] : [
        { title: 'Batch Pembayaran BBM', routeName: 'fuel-payment-batch' },
        { title: `Detail Transaksi - ${response.result.Code}`, routeName: 'fuel-payment-batch-transaction-detail' }
      ])

      // Fetch history data after detail is loaded
      await fetchHistory()
    }
  } catch (err) {
    console.error(err)
  } finally {
    isLoadingDetail.value = false
  }
}

const viewFullImage = (path?: string) => {
  if (path) {
    const fullUrl = getFullImageUrl(path)
    window.open(fullUrl, '_blank')
  }
}

const goBack = () => {
  router.push({ name: 'fuel-payment-batch' })
}

const checkerVerificationAct = async (notes: any = null) => {
  const payload = {
    Id: transactionDetail.value?.FuelingPaymentBatchId,
    FuelingTransactionId: transactionDetail.value?.Id,
    Status: notes ? 'Pending' : 'Completed',
    Notes: notes
  }
  try {
    await apiUseCase.postWithNoId(`${fuelingPaymentBatchEndpoint}/${payload.Id}/FuelingTransactions/${payload.FuelingTransactionId}/CheckerVerification`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({ severity: 'success', summary: 'Transaksi Berhasil Diverifikasi', detail: `Transaksi ${transactionDetail.value?.Code ?? '-'} sudah diverifikasi dengan hasil ${notes ? '“Tidak Cocok”' : '“Cocok”'}`, group: 'bc', life: 3000 })
        if (headerData.value?.FuelingTransactionConfirmedCount + 1 === headerData.value?.TotalTransaction) {
          goBack()
        } else {
          router.push({
            name: 'fuel-payment-batch-detail',
            params: { id: encryptDecriptMethods.encrypt({ origin: origin.value, data: headerData.value }) }
          })
        }
      } else {
        $toast.add({ severity: 'error', summary: 'Transaksi Gagal Diverifikasi', detail: message, group: 'bc', life: 3000 })
      }
    })
  } catch (error) {
    $toast.add({ severity: 'error', summary: 'Transaksi Gagal Diverifikasi', detail: error, group: 'bc', life: 3000 })
  }
  isShowCheckerPendingDialog.value = false
}

const financeVerificationAct = async (notes: string|null = null, data: any = null) => {
  const payload = notes ? {
    Id: transactionDetail.value?.FuelingPaymentBatchId,
    FuelingTransactionId: transactionDetail.value?.Id,
    Status: notes ? 'Completed' : 'Refund',
    Notes: notes,
    FuelingTransactionRevision: data
  } : {
    Id: transactionDetail.value?.FuelingPaymentBatchId,
    ...data
  }
  try {
    await apiUseCase.postWithNoId(`${fuelingPaymentBatchEndpoint}/${payload.Id}/FuelingTransactions/${payload.FuelingTransactionId}/FinanceVerification`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({ severity: 'success', summary: `Transaksi ${notes ? 'Batal' : 'Berhasil'} Direfund`, detail: `Transaksi ${transactionDetail.value?.Code ?? '-'} ${notes ? 'Batal' : 'Berhasil'} direfund`, group: 'bc', life: 3000 })
        if (headerData.value?.FuelingTransactionConfirmedCount + 1 === headerData.value?.TotalTransaction) {
          goBack()
        } else {
          router.push({
            name: 'fuel-payment-batch-detail',
            params: { id: encryptDecriptMethods.encrypt({ origin: origin.value, data: headerData.value }) }
          })
        }
      } else {
        $toast.add({ severity: 'error', summary: 'Transaksi Gagal Direfund', detail: message, group: 'bc', life: 3000 })
      }
    })
  } catch (error) {
    $toast.add({ severity: 'error', summary: 'Transaksi Gagal Direfund', detail: error, group: 'bc', life: 3000 })
  }
  isShowCheckerPendingDialog.value = false
}

onMounted(() => {
  // Set initial breadcrumb while loading
  store.dispatch('ui/setBreadcrumbs', headerData.value ? [
    { title: 'Batch Pembayaran BBM', routeName: 'fuel-payment-batch' },
    {
      title: `Detail Batch - ${headerData.value?.Code}`,
      routeName: 'fuel-payment-batch-detail',
      params: { id: encryptDecriptMethods.encrypt({ origin: origin.value, data: headerData.value }) }
    },
    { title: 'Detail Transaksi', routeName: 'fuel-payment-batch-transaction-detail' }
  ] : [
    { title: 'Batch Pembayaran BBM', routeName: 'fuel-payment-batch' },
    { title: 'Detail Transaksi', routeName: 'fuel-payment-batch-transaction-detail' }
  ])

  if (route.params.id) {
    try {
      // Decrypt ID
      const decryptedData = encryptDecriptMethods.decrypt(route.params.id as string)
      const id = typeof decryptedData === 'string' ? decryptedData : (decryptedData.Id || decryptedData)
      origin.value = decryptedData.origin
      headerData.value = decryptedData?.batchData

      // Initialize tab and fetch data
      activeHistoryTab.value = 'nopol'
      historyPaginate.value.pageNumber = 1

      fetchDetailData(id)
    } catch (e) {
      console.error('Error decrypting route param', e)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FuelingTransactionDetailCard, {
      transactionDetail: _unref(transactionDetail),
      isLoadingDetail: _unref(isLoadingDetail),
      historyData: _unref(historyData),
      isLoadingHistory: _unref(isLoadingHistory),
      activeHistoryTab: _unref(activeHistoryTab),
      historyPaginate: _unref(historyPaginate),
      isHistoryVisible: showTransactionHistory.value,
      onToggleHistory: _cache[5] || (_cache[5] = ($event: any) => (showTransactionHistory.value = !showTransactionHistory.value)),
      onChangeHistoryTab: _unref(onChangeHistoryTab),
      onChangeHistoryPage: _unref(onChangeHistoryPage),
      onViewEvidence: _cache[6] || (_cache[6] = ($event: any) => (showEvidenceImage.value = true)),
      onBack: goBack
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(origin) === 'checker' && _unref(checkActionAllowedRoles)(['Admin', 'Setoran']) && _unref(transactionDetail)?.ApprovalStatus === 'Paid')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(transactionDetail).TransactionType !== 'Refund')
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      class: "btn-back mb-4 md:mb-0",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowCheckerPendingDialog.value = true))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(Button), {
                  class: "btn-primary mr-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (checkerVerificationAct()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]))
            : (_unref(origin) === 'finance' && _unref(checkActionAllowedRoles)(['Admin', 'Keuangan']) && _unref(transactionDetail)?.ApprovalStatus === 'Pending')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_unref(Button), {
                    class: "btn-back mb-4 md:mb-0",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowFinanceCompletedForm.value = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    class: "btn-primary mr-1",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowFinanceRefundForm.value = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock(_unref(Button), {
                  key: 2,
                  class: "btn-default bg-neutral-200 border-neutral-200 text-black hover:bg-neutral-300 w-32 justify-center",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goBack()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }))
        ])
      ]),
      _: 1
    }, 8, ["transactionDetail", "isLoadingDetail", "historyData", "isLoadingHistory", "activeHistoryTab", "historyPaginate", "isHistoryVisible", "onChangeHistoryTab", "onChangeHistoryPage"]),
    _createVNode(_unref(Dialog), {
      visible: showEvidenceImage.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((showEvidenceImage).value = $event)),
      modal: true,
      header: "Detail Foto",
      breakpoints: { '960px': '90vw', '640px': '95vw' },
      style: { width: '75vw' },
      class: "images-viewer-dialog",
      contentClass: "p-6 bg-neutral-50 rounded-b-2xl"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _unref(transactionDetail)?.FuelingTransactionRevision?.EvidenceImageUrl,
          alt: "img",
          class: "mx-auto cursor-pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (viewFullImage(_unref(transactionDetail)?.FuelingTransactionRevision?.EvidenceImageUrl)))
        }, null, 8, _hoisted_10),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(Button), {
            class: "btn-back",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (showEvidenceImage.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(HjpDefaultModal, {
      show: isShowCheckerPendingDialog.value,
      onHideDialog: _cache[11] || (_cache[11] = ($event: any) => (isShowCheckerPendingDialog.value = false)),
      hasTitle: true
    }, {
      title: _withCtx(() => [
        _hoisted_13
      ]),
      content: _withCtx(() => [
        _createVNode(PendingPage, {
          onHideDialog: _cache[10] || (_cache[10] = ($event: any) => (isShowCheckerPendingDialog.value = false)),
          onSubmit: checkerVerificationAct,
          data: _unref(transactionDetail)
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(FinanceRefundForm, {
      isShow: isShowFinanceRefundForm.value,
      data: _unref(transactionDetail),
      onClose: _cache[12] || (_cache[12] = ($event: any) => (isShowFinanceRefundForm.value = false)),
      onSubmit: financeVerificationAct
    }, null, 8, ["isShow", "data"]),
    _createVNode(HjpDefaultModal, {
      show: isShowFinanceCompletedForm.value,
      onHideDialog: _cache[14] || (_cache[14] = ($event: any) => (isShowFinanceCompletedForm.value = false)),
      hasTitle: true
    }, {
      title: _withCtx(() => [
        _hoisted_14
      ]),
      content: _withCtx(() => [
        _createVNode(FinanceCompletedPage, {
          onHideDialog: _cache[13] || (_cache[13] = ($event: any) => (isShowFinanceCompletedForm.value = false)),
          onSubmit: financeVerificationAct,
          data: _unref(transactionDetail)
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})